export default {
	capitalize(_string) {
		return _string.charAt(0).toUpperCase() + _string.slice(1);
	},

	cutString(longStr, max = 20) {
		const maxChar = max;

		if (longStr.length >= maxChar) {
			return `${longStr.slice(0, maxChar)}...`;
			// return longStr.substring(0, maxChar) + '...';
		}
		return longStr;
	},

	isMail(string) {
		const expresion =
			/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

		if (expresion.test(string)) {
			return true;
		} else {
			return false;
		}
	},
	isUrl(string) {
		const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

		const localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
		const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

		if (typeof string !== "string") {
			return false;
		}

		const match = string.match(protocolAndDomainRE);
		if (!match) {
			return false;
		}

		const everythingAfterProtocol = match[1];
		if (!everythingAfterProtocol) {
			return false;
		}

		if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
			return true;
		}

		return false;
	},

	allowed_extension() {
		return ["jpg", "jpeg", "png", "gif", "bmp", "pdf", "txt", "csv", "xls", "xlsx"];
	},

	checkExt(filename) {
		const extensions = this.allowed_extension();
		let nameFile = filename.name;
		nameFile = nameFile.toLowerCase();
		const ext = nameFile.substr(nameFile.lastIndexOf(".") + 1);
		const isValid = extensions.indexOf(ext) > -1;
		return {valid: isValid, ext};
	},

	genders(url, method, data, onSuccess, onError) {
		return [
			{id: 1, name: "Male"},
			{id: 2, name: "Female"},
			{id: 3, name: "Other"},
		];
	},

	generateDonwloadFile(data, type, fileName) {
		const oMyBlob = new Blob([data], {type});
		const url = URL.createObjectURL(oMyBlob);
		const element = document.createElement("a");
		element.setAttribute("href", url);
		element.setAttribute("download", fileName);
		element.style.display = "none";
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
		return url;
	},
};
